import { Store } from 'redux';

import { invalidateFrameIfInitialized } from '../../three/reactThreeFiberBindings';
import { RootState } from '..';
import { cameraPropertiesHandler, panRestrictionsHandler } from './cameraHandler';
import { designCameraZoomCapBoundingBoxSizeHandler } from './designCameraZoomCapHandler';
import { mousyProfileInsertionHandler } from './mousyProfileInsertionHandler';

const selectorHandlers = [
  panRestrictionsHandler,
  mousyProfileInsertionHandler,
  cameraPropertiesHandler,
  designCameraZoomCapBoundingBoxSizeHandler,
];

export default (store: Store<RootState>) => {
  let currentState = store.getState();
  const initializedSelectorHandlers = selectorHandlers.map((selectorHandler) => selectorHandler(currentState));
  let handlingChange = false;
  store.subscribe(() => {
    if (!handlingChange) {
      handlingChange = true;
      while (currentState !== store.getState()) {
        const previousState = currentState;
        currentState = store.getState();
        const rootChange = { previousState, currentState, parentChange: null };
        initializedSelectorHandlers.forEach((handler) => handler(rootChange));
        invalidateFrameIfInitialized();
      }
      handlingChange = false;
    }
  });
};
